import Player from '@/components/TourBag/Player';
import { ActivePlayerProvider } from '@/context/ActivePlayerContext';
import { PhotoCacheProvider } from '@/context/PhotoCacheContext';
import PlayerNavbar from '@/layout/PlayerNavbar/PlayerNavbar';
import styles from './PlayerPage.module.scss';

function PlayerPage() {
  return (
    <ActivePlayerProvider>
      <PhotoCacheProvider>
        <div className={styles.playerPage}>
          <PlayerNavbar />
          <main className={styles.content}>
            <Player />
          </main>
        </div>
      </PhotoCacheProvider>
    </ActivePlayerProvider>
  );
}

export default PlayerPage;
